import { useLocation } from "react-router-dom";

export const useNavigationPosition = () => {
  const { pathname } = useLocation();

  const isTitle = pathname.includes("/titleJournal/") && !pathname.includes("/section");
  const isSectionOne = /\/section1\/?$/.test(pathname);
  const isSectionTwo = /\/section2\/?$/.test(pathname);
  const isSectionThree = /\/section3\/?$/.test(pathname);
  const isSectionFour = /\/section4\/?$/.test(pathname);

  // ─── Список версий ОЖР ─ versions/:titleId/ ─────────────────────────────────
  // Пример: .../mainJournalId/:id/versions/:titleId/
  // versions/:mainJournalVersionId/titleJournal
  const isJournalVersionTitle =
    pathname.includes("/versions/") &&
    (pathname.endsWith("/titleJournal") || pathname.endsWith("/titleJournal/"));

  // ─── Базовый признак «находимся внутри titleJournal» ────────────────────────
  // true для: .../titleJournal/:titleId/... (НЕ для isJournalVersionTitle)
  // titleJournal/:titleId/new
  const isTitleVersionNew =
    isTitle &&
    !pathname.includes("/amendments/") &&
    (pathname.endsWith("/new") || pathname.endsWith("/new/"));

  const isTitleVersionsList =
    pathname.includes("/titleJournal/") &&
    pathname.includes("/title-versions") &&
    !pathname.match(/\/title-versions\/[^/]+/);
  // ─── Просмотр конкретной версии титула ─ titleJournal/:id/version/:versionId ─
  // Пример: .../titleJournal/:titleId/version/v5
  const isTitleVersionDetail =
    pathname.includes("/titleJournal/") &&
    !!pathname.match(/\/version\/[^/]+/);

  // ─── Новая заявка на изменение ─ titleJournal/:id/new ───────────────────────
  // Пример: .../titleJournal/:titleId/new
  const isTitleChangeRequestsList =
    pathname.includes("/titleJournal/") &&
    pathname.includes("/title-change-requests") &&
    !pathname.includes("/title-change-requests/new");

  const isTitleChangeRequestNew =
    pathname.includes("/titleJournal/") &&
    pathname.includes("/title-change-requests/new");

  const isJournalVersionsList =
    pathname.includes("/versions/") && !isJournalVersionTitle;

  const isJournalVersionDetail = !!pathname.match(/\/version\/[^/]+\/[^/]+/);

  // true когда просматриваем раздел (section1-6) внутри версии журнала
  const isInJournalVersionSection =
    pathname.includes("/versions/") && /\/section\d+/.test(pathname);

  const isTitleRoute =
    isTitle &&
    !isTitleVersionsList &&
    !isTitleVersionDetail &&
    !isTitleChangeRequestsList &&
    !isTitleChangeRequestNew;

  const pathSegments = pathname.split("/").filter(Boolean);
  const titleTailSegment = isTitleRoute
    ? pathSegments[pathSegments.length - 1]
    : "";

  const isTitleAmendmentsList = isTitleRoute && titleTailSegment === "amendments";
  const isTitleAmendmentsNew =
    isTitle && /\/amendments\/new\/?$/.test(pathname);
  const isTitleAmendmentsView =
    isTitle && /\/amendments\/view\/[^/]+\/?$/.test(pathname);
  const isTitleAmendmentsForm =
    isTitleAmendmentsNew || isTitleAmendmentsView;
  const isTitleAmendmentsViewport = isTitleAmendmentsList || isTitleAmendmentsForm;

  return {
    isSectionOne,
    isSectionTwo,
    isSectionThree,
    isSectionFour,
    isTitle: isTitleRoute,
    isTitleAmendmentsList,
    isTitleAmendmentsNew,
    isTitleAmendmentsView,
    isTitleAmendmentsForm,
    isTitleAmendmentsViewport,
    titleTailSegment,
    isJournalVersionTitle,
    isTitleVersionNew,
    isTitleVersionsList,
    isTitleVersionDetail,
    isTitleChangeRequestsList,
    isTitleChangeRequestNew,
    isJournalVersionsList,
    isJournalVersionDetail,
    isInJournalVersionSection,
  };
};
